import React from 'react'
import QuestionnaireArea from "./QuestionnaireArea"

export default class extends React.Component {
  static defaultProps = {
    locale: 'fi',
    newCodeCallback: () => null
  };

  state = {
    code: ''
  };

  sendCode = (e) => {
    e && e.preventDefault()
    this.props.newCodeCallback(this.state.code)
  };

  render() {

    return (
      <div className="re-enter-code modal show" tabIndex="-1" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <h2> {I18N._("There was a problem submitting the answers with the code")} </h2>
              <p>
                {I18N._("It's possible somebody has used your code while you were filling the form. Nothing to worry about. Just enter a new unused code here:")}
              </p>
              <input onChange={(e) => this.setState({code: e.target.value})}
                     value={this.state.code}
                     type="text" size="6" maxLength="6"
                     className="form-control input-large"/>
            </div>
            <div className="modal-footer">
              <button className="btn btn-success" onClick={this.sendCode}>
                {I18N._("Submit answers")}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}